import { Action } from '@ngrx/store'
import { InternationalData } from '../../shared/international-data/international-data'

export enum InternationalDataEffectActionTypes {
  InternationalDataLoadSuccess = '[InternationalDataEffect] Load InternationalData Success',
  InternationalDataLoadFail = '[InternationalDataEffect] Load InternationalData Fail',
}

export class InternationalDataLoadSuccess implements Action {
  readonly type = InternationalDataEffectActionTypes.InternationalDataLoadSuccess

  constructor(public list: InternationalData[]) {}
}

export class InternationalDataLoadFail implements Action {
  readonly type = InternationalDataEffectActionTypes.InternationalDataLoadFail
}

export type InternationalDataEffectActions = InternationalDataLoadSuccess | InternationalDataLoadFail
